import React, { useState } from 'react';
import { Modal, Form, Input } from 'antd';
import { extendPreClearance } from '@app/api/pre-clearance.api';

interface ExtensionPopupProps {
  visible: boolean;
  preClearanceId: number;
  onClose: () => void;
  onSubmit: () => void;
  isLoading?: boolean;
}

const ExtensionPopup: React.FC<ExtensionPopupProps> = ({
  visible,
  preClearanceId,
  onClose,
  onSubmit,
  isLoading = false,
}) => {
  const [file, setFile] = useState<File | null>(null);
  const [error, setError] = useState('');

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      setFile(e.target.files[0]);
    }
  };

  const handleSubmit = async () => {
    if (!file) {
      setError('Please upload a file');
      return;
    }

    setError('');

    try {
      const formData = new FormData();
      formData.append('extension_req', file);

      await extendPreClearance(preClearanceId, formData);
      onSubmit(); // Call the onSubmit prop to handle successful submission
      onClose(); // Close popup on success
    } catch (err) {
      setError('Failed to submit extension request.');
    }
  };

  return (
    <Modal title="Request Extension" open={visible} onOk={handleSubmit} confirmLoading={isLoading} onCancel={onClose}>
      <Form layout="vertical">
        <Form.Item label="Upload Extension File">
          <input type="file" onChange={handleFileChange} accept="application/pdf" />
        </Form.Item>
        {error && <p className="error">{error}</p>}
      </Form>
    </Modal>
  );
};

export default ExtensionPopup;
